import { lowerCaseAllWordsExceptFirstLetters } from './utils';

export const US_STATES = [{
  name: 'ALABAMA',
  abbreviation: 'AL',
}, {
  name: 'ALASKA',
  abbreviation: 'AK',
}, {
  name: 'AMERICAN SAMOA',
  abbreviation: 'AS',
}, {
  name: 'ARIZONA',
  abbreviation: 'AZ',
}, {
  name: 'ARKANSAS',
  abbreviation: 'AR',
}, {
  name: 'CALIFORNIA',
  abbreviation: 'CA',
}, {
  name: 'COLORADO',
  abbreviation: 'CO',
}, {
  name: 'CONNECTICUT',
  abbreviation: 'CT',
}, {
  name: 'DELAWARE',
  abbreviation: 'DE',
}, {
  name: 'DISTRICT OF COLUMBIA',
  abbreviation: 'DC',
}, {
  name: 'FEDERATED STATES OF MICRONESIA',
  abbreviation: 'FM',
}, {
  name: 'FLORIDA',
  abbreviation: 'FL',
}, {
  name: 'GEORGIA',
  abbreviation: 'GA',
}, {
  name: 'GUAM',
  abbreviation: 'GU',
}, {
  name: 'HAWAII',
  abbreviation: 'HI',
}, {
  name: 'IDAHO',
  abbreviation: 'ID',
}, {
  name: 'ILLINOIS',
  abbreviation: 'IL',
}, {
  name: 'INDIANA',
  abbreviation: 'IN',
}, {
  name: 'IOWA',
  abbreviation: 'IA',
}, {
  name: 'KANSAS',
  abbreviation: 'KS',
}, {
  name: 'KENTUCKY',
  abbreviation: 'KY',
}, {
  name: 'LOUISIANA',
  abbreviation: 'LA',
}, {
  name: 'MAINE',
  abbreviation: 'ME',
}, {
  name: 'MARSHALL ISLANDS',
  abbreviation: 'MH',
}, {
  name: 'MARYLAND',
  abbreviation: 'MD',
}, {
  name: 'MASSACHUSETTS',
  abbreviation: 'MA',
}, {
  name: 'MICHIGAN',
  abbreviation: 'MI',
}, {
  name: 'MINNESOTA',
  abbreviation: 'MN',
}, {
  name: 'MISSISSIPPI',
  abbreviation: 'MS',
}, {
  name: 'MISSOURI',
  abbreviation: 'MO',
}, {
  name: 'MONTANA',
  abbreviation: 'MT',
}, {
  name: 'NEBRASKA',
  abbreviation: 'NE',
}, {
  name: 'NEVADA',
  abbreviation: 'NV',
}, {
  name: 'NEW HAMPSHIRE',
  abbreviation: 'NH',
}, {
  name: 'NEW JERSEY',
  abbreviation: 'NJ',
}, {
  name: 'NEW MEXICO',
  abbreviation: 'NM',
}, {
  name: 'NEW YORK',
  abbreviation: 'NY',
}, {
  name: 'NORTH CAROLINA',
  abbreviation: 'NC',
}, {
  name: 'NORTH DAKOTA',
  abbreviation: 'ND',
}, {
  name: 'NORTHERN MARIANA ISLANDS',
  abbreviation: 'MP',
}, {
  name: 'OHIO',
  abbreviation: 'OH',
}, {
  name: 'OKLAHOMA',
  abbreviation: 'OK',
}, {
  name: 'OREGON',
  abbreviation: 'OR',
}, {
  name: 'PALAU',
  abbreviation: 'PW',
}, {
  name: 'PENNSYLVANIA',
  abbreviation: 'PA',
}, {
  name: 'PUERTO RICO',
  abbreviation: 'PR',
}, {
  name: 'RHODE ISLAND',
  abbreviation: 'RI',
}, {
  name: 'SOUTH CAROLINA',
  abbreviation: 'SC',
}, {
  name: 'SOUTH DAKOTA',
  abbreviation: 'SD',
}, {
  name: 'TENNESSEE',
  abbreviation: 'TN',
}, {
  name: 'TEXAS',
  abbreviation: 'TX',
}, {
  name: 'UTAH',
  abbreviation: 'UT',
}, {
  name: 'VERMONT',
  abbreviation: 'VT',
}, {
  name: 'VIRGIN ISLANDS',
  abbreviation: 'VI',
}, {
  name: 'VIRGINIA',
  abbreviation: 'VA',
}, {
  name: 'WASHINGTON',
  abbreviation: 'WA',
}, {
  name: 'WEST VIRGINIA',
  abbreviation: 'WV',
}, {
  name: 'WISCONSIN',
  abbreviation: 'WI',
}, {
  name: 'WYOMING',
  abbreviation: 'WY',
}];

export const CA_STATES = [{
  name: 'ALBERTA',
  abbreviation: 'AB',
}, {
  name: 'BRITISH COLUMBIA',
  abbreviation: 'BC',
}, {
  name: 'MANITOBA',
  abbreviation: 'MB',
}, {
  name: 'NEW BRUNSWICK',
  abbreviation: 'NB',
}, {
  name: 'NEWFOUNDLAND AND LABRADOR',
  abbreviation: 'NL',
}, {
  name: 'NORTHWEST TERRITORIES',
  abbreviation: 'NT',
}, {
  name: 'NOVA SCOTIA',
  abbreviation: 'NS',
}, {
  name: 'NUNAVUT',
  abbreviation: 'NU',
}, {
  name: 'ONTARIO',
  abbreviation: 'ON',
}, {
  name: 'PRINCE EDWARD ISLAND',
  abbreviation: 'PE',
}, {
  name: 'QUEBEC',
  abbreviation: 'QC',
}, {
  name: 'SASKATCHEWAN',
  abbreviation: 'SK',
}, {
  name: 'YUKON TERRITORY',
  abbreviation: 'YT',
}];

export const AU_STATES = [{
  name: 'Australian Capital Territory',
  abbreviation: 'ACT',
}, {
  name: 'New South Wales',
  abbreviation: 'NSW',
}, {
  name: 'Northern Territory',
  abbreviation: 'NT',
}, {
  name: 'Queensland',
  abbreviation: 'QLD',
}, {
  name: 'South Australia',
  abbreviation: 'SA',
}, {
  name: 'Tasmania',
  abbreviation: 'TAS',
}, {
  name: 'Victoria',
  abbreviation: 'VIC',
}, {
  name: 'Western Australia',
  abbreviation: 'WA',
}];

export const GB_STATES = [{
    name: 'ABERCONWY AND COLWYN ',
    abbreviation: 'I0',
  },
  {
    name: 'ABERDEEN CITY ',
    abbreviation: 'I1',
  },
  {
    name: 'ABERDEENSHIRE ',
    abbreviation: 'I2',
  },
  {
    name: 'ANGLESEY ',
    abbreviation: 'I3',
  },
  {
    name: 'ANGUS ',
    abbreviation: 'I4',
  },
  {
    name: 'ANTRIM ',
    abbreviation: 'I5',
  },
  {
    name: 'ARGYLL AND BUTE ',
    abbreviation: 'I6',
  },
  {
    name: 'ARMAGH ',
    abbreviation: 'I7',
  },
  {
    name: 'AVON ',
    abbreviation: 'I8',
  },
  {
    name: 'AYRSHIRE ',
    abbreviation: 'I9',
  },
  {
    name: 'BATH AND NE SOMERSET ',
    abbreviation: 'IB',
  },
  {
    name: 'BEDFORDSHIRE ',
    abbreviation: 'IC',
  },
  {
    name: 'BELFAST ',
    abbreviation: 'IE',
  },
  {
    name: 'BERKSHIRE ',
    abbreviation: 'IF',
  },
  {
    name: 'BERWICKSHIRE ',
    abbreviation: 'IG',
  },
  {
    name: 'BFPO ',
    abbreviation: 'IH',
  },
  {
    name: 'BLAENAU GWENT ',
    abbreviation: 'II',
  },
  {
    name: 'BUCKINGHAMSHIRE ',
    abbreviation: 'IJ',
  },
  {
    name: 'CAERNARFONSHIRE ',
    abbreviation: 'IK',
  },
  {
    name: 'CAERPHILLY ',
    abbreviation: 'IM',
  },
  {
    name: 'CAITHNESS ',
    abbreviation: 'IO',
  },
  {
    name: 'CAMBRIDGESHIRE ',
    abbreviation: 'IP',
  },
  {
    name: 'CARDIFF ',
    abbreviation: 'IQ',
  },
  {
    name: 'CARDIGANSHIRE ',
    abbreviation: 'IR',
  },
  {
    name: 'CARMARTHENSHIRE ',
    abbreviation: 'IS',
  },
  {
    name: 'CEREDIGION ',
    abbreviation: 'IT',
  },
  {
    name: 'CHANNEL ISLANDS ',
    abbreviation: 'IU',
  },
  {
    name: 'CHESHIRE ',
    abbreviation: 'IV',
  },
  {
    name: 'CITY OF BRISTOL ',
    abbreviation: 'IW',
  },
  {
    name: 'CLACKMANNANSHIRE ',
    abbreviation: 'IX',
  },
  {
    name: 'CLWYD ',
    abbreviation: 'IY',
  },
  {
    name: 'CONWY ',
    abbreviation: 'IZ',
  },
  {
    name: 'CORNWALL/SCILLY ',
    abbreviation: 'J0',
  },
  {
    name: 'CUMBRIA ',
    abbreviation: 'J1',
  },
  {
    name: 'DENBIGHSHIRE ',
    abbreviation: 'J2',
  },
  {
    name: 'DERBYSHIRE ',
    abbreviation: 'J3',
  },
  {
    name: 'DERRY/LONDONDERRY ',
    abbreviation: 'J4',
  },
  {
    name: 'DEVON ',
    abbreviation: 'J5',
  },
  {
    name: 'DORSET ',
    abbreviation: 'J6',
  },
  {
    name: 'DOWN ',
    abbreviation: 'J7',
  },
  {
    name: 'DUMFRIES AND GALLOWAY ',
    abbreviation: 'J8',
  },
  {
    name: 'DUNBARTONSHIRE ',
    abbreviation: 'J9',
  },
  {
    name: 'DUNDEE ',
    abbreviation: 'JA',
  },
  {
    name: 'DURHAM ',
    abbreviation: 'JB',
  },
  {
    name: 'DYFED ',
    abbreviation: 'JC',
  },
  {
    name: 'EAST AYRSHIRE ',
    abbreviation: 'JD',
  },
  {
    name: 'EAST DUNBARTONSHIRE ',
    abbreviation: 'JE',
  },
  {
    name: 'EAST LOTHIAN ',
    abbreviation: 'JF',
  },
  {
    name: 'EAST RENFREWSHIRE ',
    abbreviation: 'JG',
  },
  {
    name: 'EAST RIDING YORKSHIRE ',
    abbreviation: 'JH',
  },
  {
    name: 'EAST SUSSEX ',
    abbreviation: 'JI',
  },
  {
    name: 'EDINBURGH ',
    abbreviation: 'JJ',
  },
  {
    name: 'ENGLAND ',
    abbreviation: 'JK',
  },
  {
    name: 'ESSEX ',
    abbreviation: 'JL',
  },
  {
    name: 'FALKIRK ',
    abbreviation: 'JM',
  },
  {
    name: 'FERMANAGH ',
    abbreviation: 'JN',
  },
  {
    name: 'FIFE ',
    abbreviation: 'JO',
  },
  {
    name: 'FLINTSHIRE ',
    abbreviation: 'JP',
  },
  {
    name: 'GLASGOW ',
    abbreviation: 'JQ',
  },
  {
    name: 'GLOUCESTERSHIRE ',
    abbreviation: 'JR',
  },
  {
    name: 'GREATER LONDON ',
    abbreviation: 'JS',
  },
  {
    name: 'GREATER MANCHESTER ',
    abbreviation: 'JT',
  },
  {
    name: 'GWENT ',
    abbreviation: 'JU',
  },
  {
    name: 'GWYNEDD ',
    abbreviation: 'JV',
  },
  {
    name: 'HAMPSHIRE ',
    abbreviation: 'JW',
  },
  {
    name: 'HARTLEPOOL ',
    abbreviation: 'JX',
  },
  {
    name: 'HEREFORD AND WORCESTER ',
    abbreviation: 'HAW',
  },
  {
    name: 'HERTFORDSHIRE ',
    abbreviation: 'JY',
  },
  {
    name: 'HIGHLANDS ',
    abbreviation: 'JZ',
  },
  {
    name: 'INVERCLYDE ',
    abbreviation: 'K0',
  },
  {
    name: 'INVERNESS-SHIRE ',
    abbreviation: 'K1',
  },
  {
    name: 'ISLE OF MAN ',
    abbreviation: 'K2',
  },
  {
    name: 'ISLE OF WIGHT ',
    abbreviation: 'K3',
  },
  {
    name: 'KENT ',
    abbreviation: 'K4',
  },
  {
    name: 'KINCARDINSHIRE ',
    abbreviation: 'K5',
  },
  {
    name: 'KINGSTON UPON HULL ',
    abbreviation: 'K6',
  },
  {
    name: 'KINROSS-SHIRE ',
    abbreviation: 'K7',
  },
  {
    name: 'KIRKLEES ',
    abbreviation: 'K8',
  },
  {
    name: 'LANARKSHIRE ',
    abbreviation: 'K9',
  },
  {
    name: 'LANCASHIRE ',
    abbreviation: 'KA',
  },
  {
    name: 'LEICESTERSHIRE ',
    abbreviation: 'KB',
  },
  {
    name: 'LINCOLNSHIRE ',
    abbreviation: 'KC',
  },
  {
    name: 'LONDONDERRY ',
    abbreviation: 'KD',
  },
  {
    name: 'MERSEYSIDE ',
    abbreviation: 'KE',
  },
  {
    name: 'MERTHYR TYDFIL ',
    abbreviation: 'KF',
  },
  {
    name: 'MID GLAMORGAN ',
    abbreviation: 'KG',
  },
  {
    name: 'MID LOTHIAN ',
    abbreviation: 'KI',
  },
  {
    name: 'MIDDLESEX ',
    abbreviation: 'KH',
  },
  {
    name: 'MONMOUTHSHIRE ',
    abbreviation: 'KJ',
  },
  {
    name: 'MORAY ',
    abbreviation: 'KK',
  },
  {
    name: 'NEATH & PORT TALBOT ',
    abbreviation: 'KL',
  },
  {
    name: 'NEWPORT ',
    abbreviation: 'KM',
  },
  {
    name: 'NORFOLK ',
    abbreviation: 'KN',
  },
  {
    name: 'NORTH AYRSHIRE ',
    abbreviation: 'KP',
  },
  {
    name: 'NORTH EAST LINCOLNSHIRE ',
    abbreviation: 'KQ',
  },
  {
    name: 'NORTH LANARKSHIRE ',
    abbreviation: 'KR',
  },
  {
    name: 'NORTH LINCOLNSHIRE ',
    abbreviation: 'KT',
  },
  {
    name: 'NORTH SOMERSET ',
    abbreviation: 'KU',
  },
  {
    name: 'NORTH YORKSHIRE ',
    abbreviation: 'KV',
  },
  {
    name: 'NORTHAMPTONSHIRE ',
    abbreviation: 'KO',
  },
  {
    name: 'NORTHERN IRELAND ',
    abbreviation: 'KW',
  },
  {
    name: 'NORTHUMBERLAND ',
    abbreviation: 'KX',
  },
  {
    name: 'NOTTINGHAMSHIRE ',
    abbreviation: 'KZ',
  },
  {
    name: 'ORKNEY AND SHETLAND ISLES ',
    abbreviation: 'L0',
  },
  {
    name: 'OXFORDSHIRE ',
    abbreviation: 'L1',
  },
  {
    name: 'PEMBROKESHIRE ',
    abbreviation: 'L2',
  },
  {
    name: 'PERTH AND KINROSS ',
    abbreviation: 'L3',
  },
  {
    name: 'POWYS ',
    abbreviation: 'L4',
  },
  {
    name: 'REDCAR AND CLEVELAND ',
    abbreviation: 'L5',
  },
  {
    name: 'RENFREWSHIRE ',
    abbreviation: 'L6',
  },
  {
    name: 'RHONDA CYNON TAFF ',
    abbreviation: 'L7',
  },
  {
    name: 'RUTLAND ',
    abbreviation: 'L8',
  },
  {
    name: 'SCOTTISH BORDERS ',
    abbreviation: 'L9',
  },
  {
    name: 'SHETLAND ',
    abbreviation: 'LB',
  },
  {
    name: 'SHROPSHIRE ',
    abbreviation: 'LC',
  },
  {
    name: 'SOMERSET ',
    abbreviation: 'LD',
  },
  {
    name: 'SOUTH AYRSHIRE ',
    abbreviation: 'LE',
  },
  {
    name: 'SOUTH GLAMORGAN ',
    abbreviation: 'LF',
  },
  {
    name: 'SOUTH GLOUCESTESHIRE ',
    abbreviation: 'LG',
  },
  {
    name: 'SOUTH LANARKSHIRE ',
    abbreviation: 'LH',
  },
  {
    name: 'SOUTH YORKSHIRE ',
    abbreviation: 'LI',
  },
  {
    name: 'STAFFORDSHIRE ',
    abbreviation: 'LJ',
  },
  {
    name: 'STIRLING ',
    abbreviation: 'LK',
  },
  {
    name: 'STOCKTON ON TEES ',
    abbreviation: 'LL',
  },
  {
    name: 'SUFFOLK ',
    abbreviation: 'LM',
  },
  {
    name: 'SURREY ',
    abbreviation: 'LN',
  },
  {
    name: 'SWANSEA ',
    abbreviation: 'LO',
  },
  {
    name: 'TORFAEN ',
    abbreviation: 'LP',
  },
  {
    name: 'TYNE AND WEAR ',
    abbreviation: 'LQ',
  },
  {
    name: 'TYRONE ',
    abbreviation: 'LR',
  },
  {
    name: 'VALE OF GLAMORGAN ',
    abbreviation: 'LS',
  },
  {
    name: 'WALES ',
    abbreviation: 'LT',
  },
  {
    name: 'WARWICKSHIRE ',
    abbreviation: 'LU',
  },
  {
    name: 'WEST BERKSHIRE ',
    abbreviation: 'LV',
  },
  {
    name: 'WEST DUNBARTONSHIRE ',
    abbreviation: 'LW',
  },
  {
    name: 'WEST GLAMORGAN ',
    abbreviation: 'LX',
  },
  {
    name: 'WEST LOTHIAN ',
    abbreviation: 'LY',
  },
  {
    name: 'WEST MIDLANDS ',
    abbreviation: 'LZ',
  },
  {
    name: 'WEST SUSSEX ',
    abbreviation: 'M0',
  },
  {
    name: 'WEST YORKSHIRE ',
    abbreviation: 'M1',
  },
  {
    name: 'WESTERN ISLES ',
    abbreviation: 'M2',
  },
  {
    name: 'WILTSHIRE ',
    abbreviation: 'M3',
  },
  {
    name: 'WIRRAL ',
    abbreviation: 'M4',
  },
  {
    name: 'WORCESTERSHIRE ',
    abbreviation: 'M5',
  },
  {
    name: 'WREXHAM ',
    abbreviation: 'M6',
  },
  {
    name: 'YORK',
    abbreviation: 'M7',
  }
];

export const WORLD_COUNTRIES = [{
  Name: 'United States',
  Code: 'US',
  Timezone: 'Pacific Standard Time',
  UTC: 'UTC-08:00',
  MobileCode: '+1',
}, {
  Name: 'Canada',
  Code: 'CA',
  Timezone: 'Eastern Standard Time',
  UTC: 'UTC-05:00',
  MobileCode: '+1',
}, {
  Name: 'United Kingdom',
  Code: 'GB',
  Timezone: 'GMT Standard Time',
  UTC: 'UTC',
  MobileCode: '+44',
}, {
  Name: 'Australia',
  Code: 'AU',
  Timezone: 'AUS Eastern Standard Time',
  UTC: 'UTC+10:00',
  MobileCode: '+61',
}, {
  Name: '',
  Code: '',
  Timezone: '',
  UTC: '',
  MobileCode: '',
}, {
  Name: 'Afghanistan',
  Code: 'AF',
  Timezone: 'Afghanistan Standard Time',
  UTC: 'UTC+04:30',
  MobileCode: '+93',
}, {
  Name: '&Aring;land Islands',
  Code: 'AX',
  Timezone: 'FLE Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+358-18',
}, {
  Name: 'Albania',
  Code: 'AL',
  Timezone: 'Central Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+355',
}, {
  Name: 'Algeria',
  Code: 'DZ',
  Timezone: 'W. Central Africa Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+213',
}, {
  Name: 'American Samoa',
  Code: 'AS',
  Timezone: 'UTC-11',
  UTC: 'UTC-11:00',
  MobileCode: '+1-684',
}, {
  Name: 'Andorra',
  Code: 'AD',
  Timezone: 'W. Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+376',
}, {
  Name: 'Angola',
  Code: 'AO',
  Timezone: 'W. Central Africa Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+244',
}, {
  Name: 'Anguilla',
  Code: 'AI',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+1-264',
}, {
  Name: 'Antarctica',
  Code: 'AQ',
  Timezone: 'Pacific SA Standard Time',
  UTC: 'UTC-03:00',
  MobileCode: '+',
}, {
  Name: 'Antigua and Barbuda',
  Code: 'AG',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+1-268',
}, {
  Name: 'Argentina',
  Code: 'AR',
  Timezone: 'Argentina Standard Time',
  UTC: 'UTC-03:00',
  MobileCode: '+54',
}, {
  Name: 'Armenia',
  Code: 'AM',
  Timezone: 'Caucasus Standard Time',
  UTC: 'UTC+04:00',
  MobileCode: '+374',
}, {
  Name: 'Aruba',
  Code: 'AW',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+297',
}, {
  Name: 'Austria',
  Code: 'AT',
  Timezone: 'W. Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+43',
}, {
  Name: 'Azerbaijan',
  Code: 'AZ',
  Timezone: 'Azerbaijan Standard Time',
  UTC: 'UTC+04:00',
  MobileCode: '+994',
}, {
  Name: 'Bahamas, The',
  Code: 'BS',
  Timezone: 'Eastern Standard Time',
  UTC: 'UTC-05:00',
  MobileCode: '+1-242',
}, {
  Name: 'Bahrain',
  Code: 'BH',
  Timezone: 'Arab Standard Time',
  UTC: 'UTC+03:00',
  MobileCode: '+973',
}, {
  Name: 'Bangladesh',
  Code: 'BD',
  Timezone: 'Bangladesh Standard Time',
  UTC: 'UTC+06:00',
  MobileCode: '+880',
}, {
  Name: 'Barbados',
  Code: 'BB',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+1-246',
}, {
  Name: 'Belarus',
  Code: 'BY',
  Timezone: 'Belarus Standard Time',
  UTC: 'UTC+03:00',
  MobileCode: '+375',
}, {
  Name: 'Belgium',
  Code: 'BE',
  Timezone: 'Romance Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+32',
}, {
  Name: 'Belize',
  Code: 'BZ',
  Timezone: 'Central America Standard Time',
  UTC: 'UTC-06:00',
  MobileCode: '+501',
}, {
  Name: 'Benin',
  Code: 'BJ',
  Timezone: 'W. Central Africa Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+229',
}, {
  Name: 'Bermuda',
  Code: 'BM',
  Timezone: 'Atlantic Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+1-441',
}, {
  Name: 'Bhutan',
  Code: 'BT',
  Timezone: 'Bangladesh Standard Time',
  UTC: 'UTC+06:00',
  MobileCode: '+975',
}, {
  Name: 'Bolivarian Republic of Venezuela',
  Code: 'VE',
  Timezone: 'Venezuela Standard Time',
  UTC: 'UTC-04:30',
  MobileCode: '+58',
}, {
  Name: 'Bolivia',
  Code: 'BO',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+591',
}, {
  Name: 'Bonaire, Sint Eustatius and Saba',
  Code: 'BQ',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+599',
}, {
  Name: 'Bosnia and Herzegovina',
  Code: 'BA',
  Timezone: 'Central European Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+387',
}, {
  Name: 'Botswana',
  Code: 'BW',
  Timezone: 'South Africa Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+267',
}, {
  Name: 'Bouvet Island',
  Code: 'BV',
  Timezone: 'UTC',
  UTC: 'UTC',
  MobileCode: '+',
}, {
  Name: 'Brazil',
  Code: 'BR',
  Timezone: 'E. South America Standard Time',
  UTC: 'UTC-03:00',
  MobileCode: '+55',
}, {
  Name: 'British Indian Ocean Territory',
  Code: 'IO',
  Timezone: 'Central Asia Standard Time',
  UTC: 'UTC+06:00',
  MobileCode: '+246',
}, {
  Name: 'Brunei',
  Code: 'BN',
  Timezone: 'Singapore Standard Time',
  UTC: 'UTC+08:00',
  MobileCode: '+673',
}, {
  Name: 'Bulgaria',
  Code: 'BG',
  Timezone: 'FLE Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+359',
}, {
  Name: 'Burkina Faso',
  Code: 'BF',
  Timezone: 'Greenwich Standard Time',
  UTC: 'UTC',
  MobileCode: '+226',
}, {
  Name: 'Burundi',
  Code: 'BI',
  Timezone: 'South Africa Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+257',
}, {
  Name: 'Cabo Verde',
  Code: 'CV',
  Timezone: 'Cape Verde Standard Time',
  UTC: 'UTC-01:00',
  MobileCode: '+238',
}, {
  Name: 'Cambodia',
  Code: 'KH',
  Timezone: 'SE Asia Standard Time',
  UTC: 'UTC+07:00',
  MobileCode: '+855',
}, {
  Name: 'Cameroon',
  Code: 'CM',
  Timezone: 'W. Central Africa Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+237',
}, {
  Name: 'Cayman Islands',
  Code: 'KY',
  Timezone: 'SA Pacific Standard Time',
  UTC: 'UTC-05:00',
  MobileCode: '+1-345',
}, {
  Name: 'Central African Republic',
  Code: 'CF',
  Timezone: 'W. Central Africa Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+236',
}, {
  Name: 'Chad',
  Code: 'TD',
  Timezone: 'W. Central Africa Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+235',
}, {
  Name: 'Chile',
  Code: 'CL',
  Timezone: 'Pacific SA Standard Time',
  UTC: 'UTC-03:00',
  MobileCode: '+56',
}, {
  Name: 'China',
  Code: 'CN',
  Timezone: 'China Standard Time',
  UTC: 'UTC+08:00',
  MobileCode: '+86',
}, {
  Name: 'Christmas Island',
  Code: 'CX',
  Timezone: 'SE Asia Standard Time',
  UTC: 'UTC+07:00',
  MobileCode: '+61',
}, {
  Name: 'Cocos (Keeling) Islands',
  Code: 'CC',
  Timezone: 'Myanmar Standard Time',
  UTC: 'UTC+06:30',
  MobileCode: '+61',
}, {
  Name: 'Colombia',
  Code: 'CO',
  Timezone: 'SA Pacific Standard Time',
  UTC: 'UTC-05:00',
  MobileCode: '+57',
}, {
  Name: 'Comoros',
  Code: 'KM',
  Timezone: 'E. Africa Standard Time',
  UTC: 'UTC+03:00',
  MobileCode: '+269',
}, {
  Name: 'Congo',
  Code: 'CG',
  Timezone: 'W. Central Africa Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+242',
}, {
  Name: 'Congo (DRC)',
  Code: 'CD',
  Timezone: 'W. Central Africa Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+243',
}, {
  Name: 'Cook Islands',
  Code: 'CK',
  Timezone: 'Hawaiian Standard Time',
  UTC: 'UTC-10:00',
  MobileCode: '+682',
}, {
  Name: 'Costa Rica',
  Code: 'CR',
  Timezone: 'Central America Standard Time',
  UTC: 'UTC-06:00',
  MobileCode: '+506',
}, {
  Name: "C&ocirc;te d'Ivoire",
  Code: 'CI',
  Timezone: 'Greenwich Standard Time',
  UTC: 'UTC',
  MobileCode: '+225',
}, {
  Name: 'Croatia',
  Code: 'HR',
  Timezone: 'Central European Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+385',
}, {
  Name: 'Cuba',
  Code: 'CU',
  Timezone: 'Eastern Standard Time',
  UTC: 'UTC-05:00',
  MobileCode: '+53',
}, {
  Name: 'Cura&ccedil;ao',
  Code: 'CW',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+599',
}, {
  Name: 'Cyprus',
  Code: 'CY',
  Timezone: 'E. Europe Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+357',
}, {
  Name: 'Czech Republic',
  Code: 'CZ',
  Timezone: 'Central Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+420',
}, {
  Name: 'Democratic Republic of Timor-Leste',
  Code: 'TL',
  Timezone: 'Tokyo Standard Time',
  UTC: 'UTC+09:00',
  MobileCode: '+670',
}, {
  Name: 'Denmark',
  Code: 'DK',
  Timezone: 'Romance Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+45',
}, {
  Name: 'Djibouti',
  Code: 'DJ',
  Timezone: 'E. Africa Standard Time',
  UTC: 'UTC+03:00',
  MobileCode: '+253',
}, {
  Name: 'Dominica',
  Code: 'DM',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+1-767',
}, {
  Name: 'Dominican Republic',
  Code: 'DO',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+1-809 and 1-829',
}, {
  Name: 'Ecuador',
  Code: 'EC',
  Timezone: 'SA Pacific Standard Time',
  UTC: 'UTC-05:00',
  MobileCode: '+593',
}, {
  Name: 'Egypt',
  Code: 'EG',
  Timezone: 'Egypt Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+20',
}, {
  Name: 'El Salvador',
  Code: 'SV',
  Timezone: 'Central America Standard Time',
  UTC: 'UTC-06:00',
  MobileCode: '+503',
}, {
  Name: 'Equatorial Guinea',
  Code: 'GQ',
  Timezone: 'W. Central Africa Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+240',
}, {
  Name: 'Eritrea',
  Code: 'ER',
  Timezone: 'E. Africa Standard Time',
  UTC: 'UTC+03:00',
  MobileCode: '+291',
}, {
  Name: 'Estonia',
  Code: 'EE',
  Timezone: 'FLE Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+372',
}, {
  Name: 'Ethiopia',
  Code: 'ET',
  Timezone: 'E. Africa Standard Time',
  UTC: 'UTC+03:00',
  MobileCode: '+251',
}, {
  Name: 'Falkland Islands (Islas Malvinas)',
  Code: 'FK',
  Timezone: 'SA Eastern Standard Time',
  UTC: 'UTC-03:00',
  MobileCode: '+500',
}, {
  Name: 'Faroe Islands',
  Code: 'FO',
  Timezone: 'GMT Standard Time',
  UTC: 'UTC',
  MobileCode: '+298',
}, {
  Name: 'Fiji Islands',
  Code: 'FJ',
  Timezone: 'Fiji Standard Time',
  UTC: 'UTC+12:00',
  MobileCode: '+679',
}, {
  Name: 'Finland',
  Code: 'FI',
  Timezone: 'FLE Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+358',
}, {
  Name: 'France',
  Code: 'FR',
  Timezone: 'Romance Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+33',
}, {
  Name: 'French Guiana',
  Code: 'GF',
  Timezone: 'SA Eastern Standard Time',
  UTC: 'UTC-03:00',
  MobileCode: '+594',
}, {
  Name: 'French Polynesia',
  Code: 'PF',
  Timezone: 'Hawaiian Standard Time',
  UTC: 'UTC-10:00',
  MobileCode: '+689',
}, {
  Name: 'French Southern and Antarctic Lands',
  Code: 'TF',
  Timezone: 'West Asia Standard Time',
  UTC: 'UTC+05:00',
  MobileCode: '+',
}, {
  Name: 'Gabon',
  Code: 'GA',
  Timezone: 'W. Central Africa Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+241',
}, {
  Name: 'Gambia, The',
  Code: 'GM',
  Timezone: 'Greenwich Standard Time',
  UTC: 'UTC',
  MobileCode: '+220',
}, {
  Name: 'Georgia',
  Code: 'GE',
  Timezone: 'Georgian Standard Time',
  UTC: 'UTC+04:00',
  MobileCode: '+995',
}, {
  Name: 'Germany',
  Code: 'DE',
  Timezone: 'W. Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+49',
}, {
  Name: 'Ghana',
  Code: 'GH',
  Timezone: 'Greenwich Standard Time',
  UTC: 'UTC',
  MobileCode: '+233',
}, {
  Name: 'Gibraltar',
  Code: 'GI',
  Timezone: 'W. Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+350',
}, {
  Name: 'Greece',
  Code: 'GR',
  Timezone: 'GTB Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+30',
}, {
  Name: 'Greenland',
  Code: 'GL',
  Timezone: 'Greenland Standard Time',
  UTC: 'UTC-03:00',
  MobileCode: '+299',
}, {
  Name: 'Grenada',
  Code: 'GD',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+1-473',
}, {
  Name: 'Guadeloupe',
  Code: 'GP',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+590',
}, {
  Name: 'Guam',
  Code: 'GU',
  Timezone: 'West Pacific Standard Time',
  UTC: 'UTC+10:00',
  MobileCode: '+1-671',
}, {
  Name: 'Guatemala',
  Code: 'GT',
  Timezone: 'Central America Standard Time',
  UTC: 'UTC-06:00',
  MobileCode: '+502',
}, {
  Name: 'Guernsey',
  Code: 'GG',
  Timezone: 'GMT Standard Time',
  UTC: 'UTC',
  MobileCode: '+44-1481',
}, {
  Name: 'Guinea',
  Code: 'GN',
  Timezone: 'Greenwich Standard Time',
  UTC: 'UTC',
  MobileCode: '+224',
}, {
  Name: 'Guinea-Bissau',
  Code: 'GW',
  Timezone: 'Greenwich Standard Time',
  UTC: 'UTC',
  MobileCode: '+245',
}, {
  Name: 'Guyana',
  Code: 'GY',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+592',
}, {
  Name: 'Haiti',
  Code: 'HT',
  Timezone: 'Eastern Standard Time',
  UTC: 'UTC-05:00',
  MobileCode: '+509',
}, {
  Name: 'Heard Island and McDonald Islands',
  Code: 'HM',
  Timezone: 'Mauritius Standard Time',
  UTC: 'UTC+04:00',
  MobileCode: '+ ',
}, {
  Name: 'Honduras',
  Code: 'HN',
  Timezone: 'Central America Standard Time',
  UTC: 'UTC-06:00',
  MobileCode: '+504',
}, {
  Name: 'Hong Kong SAR',
  Code: 'HK',
  Timezone: 'China Standard Time',
  UTC: 'UTC+08:00',
  MobileCode: '+852',
}, {
  Name: 'Hungary',
  Code: 'HU',
  Timezone: 'Central Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+36',
}, {
  Name: 'Iceland',
  Code: 'IS',
  Timezone: 'Greenwich Standard Time',
  UTC: 'UTC',
  MobileCode: '+354',
}, {
  Name: 'India',
  Code: 'IN',
  Timezone: 'India Standard Time',
  UTC: 'UTC+05:30',
  MobileCode: '+91',
}, {
  Name: 'Indonesia',
  Code: 'ID',
  Timezone: 'SE Asia Standard Time',
  UTC: 'UTC+07:00',
  MobileCode: '+62',
}, {
  Name: 'Iran',
  Code: 'IR',
  Timezone: 'Iran Standard Time',
  UTC: 'UTC+03:30',
  MobileCode: '+98',
}, {
  Name: 'Iraq',
  Code: 'IQ',
  Timezone: 'Arabic Standard Time',
  UTC: 'UTC+03:00',
  MobileCode: '+964',
}, {
  Name: 'Ireland',
  Code: 'IE',
  Timezone: 'GMT Standard Time',
  UTC: 'UTC',
  MobileCode: '+353',
}, {
  Name: 'Israel',
  Code: 'IL',
  Timezone: 'Israel Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+972',
}, {
  Name: 'Italy',
  Code: 'IT',
  Timezone: 'W. Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+39',
}, {
  Name: 'Jamaica',
  Code: 'JM',
  Timezone: 'SA Pacific Standard Time',
  UTC: 'UTC-05:00',
  MobileCode: '+1-876',
}, {
  Name: 'Jan Mayen',
  Code: 'SJ',
  Timezone: 'W. Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+47',
}, {
  Name: 'Japan',
  Code: 'JP',
  Timezone: 'Tokyo Standard Time',
  UTC: 'UTC+09:00',
  MobileCode: '+81',
}, {
  Name: 'Jersey',
  Code: 'JE',
  Timezone: 'GMT Standard Time',
  UTC: 'UTC',
  MobileCode: '+44-1534',
}, {
  Name: 'Jordan',
  Code: 'JO',
  Timezone: 'Jordan Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+962',
}, {
  Name: 'Kazakhstan',
  Code: 'KZ',
  Timezone: 'Central Asia Standard Time',
  UTC: 'UTC+06:00',
  MobileCode: '+7',
}, {
  Name: 'Kenya',
  Code: 'KE',
  Timezone: 'E. Africa Standard Time',
  UTC: 'UTC+03:00',
  MobileCode: '+254',
}, {
  Name: 'Kiribati',
  Code: 'KI',
  Timezone: 'UTC+12',
  UTC: 'UTC+12:00',
  MobileCode: '+686',
}, {
  Name: 'Korea',
  Code: 'KR',
  Timezone: 'Korea Standard Time',
  UTC: 'UTC+09:00',
  MobileCode: '+82',
}, {
  Name: 'Kosovo',
  Code: 'XK',
  Timezone: 'Central European Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+',
}, {
  Name: 'Kuwait',
  Code: 'KW',
  Timezone: 'Arab Standard Time',
  UTC: 'UTC+03:00',
  MobileCode: '+965',
}, {
  Name: 'Kyrgyzstan',
  Code: 'KG',
  Timezone: 'Central Asia Standard Time',
  UTC: 'UTC+06:00',
  MobileCode: '+996',
}, {
  Name: 'Laos',
  Code: 'LA',
  Timezone: 'SE Asia Standard Time',
  UTC: 'UTC+07:00',
  MobileCode: '+856',
}, {
  Name: 'Latvia',
  Code: 'LV',
  Timezone: 'FLE Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+371',
}, {
  Name: 'Lebanon',
  Code: 'LB',
  Timezone: 'Middle East Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+961',
}, {
  Name: 'Lesotho',
  Code: 'LS',
  Timezone: 'South Africa Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+266',
}, {
  Name: 'Liberia',
  Code: 'LR',
  Timezone: 'Greenwich Standard Time',
  UTC: 'UTC',
  MobileCode: '+231',
}, {
  Name: 'Libya',
  Code: 'LY',
  Timezone: 'E. Europe Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+218',
}, {
  Name: 'Liechtenstein',
  Code: 'LI',
  Timezone: 'W. Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+423',
}, {
  Name: 'Lithuania',
  Code: 'LT',
  Timezone: 'FLE Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+370',
}, {
  Name: 'Luxembourg',
  Code: 'LU',
  Timezone: 'W. Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+352',
}, {
  Name: 'Macao SAR',
  Code: 'MO',
  Timezone: 'China Standard Time',
  UTC: 'UTC+08:00',
  MobileCode: '+853',
}, {
  Name: 'Macedonia, Former Yugoslav Republic of',
  Code: 'MK',
  Timezone: 'Central European Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+389',
}, {
  Name: 'Madagascar',
  Code: 'MG',
  Timezone: 'E. Africa Standard Time',
  UTC: 'UTC+03:00',
  MobileCode: '+261',
}, {
  Name: 'Malawi',
  Code: 'MW',
  Timezone: 'South Africa Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+265',
}, {
  Name: 'Malaysia',
  Code: 'MY',
  Timezone: 'Singapore Standard Time',
  UTC: 'UTC+08:00',
  MobileCode: '+60',
}, {
  Name: 'Maldives',
  Code: 'MV',
  Timezone: 'West Asia Standard Time',
  UTC: 'UTC+05:00',
  MobileCode: '+960',
}, {
  Name: 'Mali',
  Code: 'ML',
  Timezone: 'Greenwich Standard Time',
  UTC: 'UTC',
  MobileCode: '+223',
}, {
  Name: 'Malta',
  Code: 'MT',
  Timezone: 'W. Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+356',
}, {
  Name: 'Man, Isle of',
  Code: 'IM',
  Timezone: 'GMT Standard Time',
  UTC: 'UTC',
  MobileCode: '+44-1624',
}, {
  Name: 'Marshall Islands',
  Code: 'MH',
  Timezone: 'UTC+12',
  UTC: 'UTC+12:00',
  MobileCode: '+692',
}, {
  Name: 'Martinique',
  Code: 'MQ',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+596',
}, {
  Name: 'Mauritania',
  Code: 'MR',
  Timezone: 'Greenwich Standard Time',
  UTC: 'UTC',
  MobileCode: '+222',
}, {
  Name: 'Mauritius',
  Code: 'MU',
  Timezone: 'Mauritius Standard Time',
  UTC: 'UTC+04:00',
  MobileCode: '+230',
}, {
  Name: 'Mayotte',
  Code: 'YT',
  Timezone: 'E. Africa Standard Time',
  UTC: 'UTC+03:00',
  MobileCode: '+262',
}, {
  Name: 'Mexico',
  Code: 'MX',
  Timezone: 'Central Standard Time (Mexico)',
  UTC: 'UTC-06:00',
  MobileCode: '+52',
}, {
  Name: 'Micronesia',
  Code: 'FM',
  Timezone: 'West Pacific Standard Time',
  UTC: 'UTC+10:00',
  MobileCode: '+691',
}, {
  Name: 'Moldova',
  Code: 'MD',
  Timezone: 'GTB Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+373',
}, {
  Name: 'Monaco',
  Code: 'MC',
  Timezone: 'W. Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+377',
}, {
  Name: 'Mongolia',
  Code: 'MN',
  Timezone: 'Ulaanbaatar Standard Time',
  UTC: 'UTC+08:00',
  MobileCode: '+976',
}, {
  Name: 'Montenegro',
  Code: 'ME',
  Timezone: 'Central European Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+382',
}, {
  Name: 'Montserrat',
  Code: 'MS',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+1-664',
}, {
  Name: 'Morocco',
  Code: 'MA',
  Timezone: 'Morocco Standard Time',
  UTC: 'UTC',
  MobileCode: '+212',
}, {
  Name: 'Mozambique',
  Code: 'MZ',
  Timezone: 'South Africa Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+258',
}, {
  Name: 'Myanmar',
  Code: 'MM',
  Timezone: 'Myanmar Standard Time',
  UTC: 'UTC+06:30',
  MobileCode: '+95',
}, {
  Name: 'Namibia',
  Code: 'NA',
  Timezone: 'Namibia Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+264',
}, {
  Name: 'Nauru',
  Code: 'NR',
  Timezone: 'UTC+12',
  UTC: 'UTC+12:00',
  MobileCode: '+674',
}, {
  Name: 'Nepal',
  Code: 'NP',
  Timezone: 'Nepal Standard Time',
  UTC: 'UTC+05:45',
  MobileCode: '+977',
}, {
  Name: 'Netherlands',
  Code: 'NL',
  Timezone: 'W. Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+31',
}, {
  Name: 'New Caledonia',
  Code: 'NC',
  Timezone: 'Central Pacific Standard Time',
  UTC: 'UTC+11:00',
  MobileCode: '+687',
}, {
  Name: 'New Zealand',
  Code: 'NZ',
  Timezone: 'New Zealand Standard Time',
  UTC: 'UTC+12:00',
  MobileCode: '+64',
}, {
  Name: 'Nicaragua',
  Code: 'NI',
  Timezone: 'Central America Standard Time',
  UTC: 'UTC-06:00',
  MobileCode: '+505',
}, {
  Name: 'Niger',
  Code: 'NE',
  Timezone: 'W. Central Africa Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+227',
}, {
  Name: 'Nigeria',
  Code: 'NG',
  Timezone: 'W. Central Africa Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+234',
}, {
  Name: 'Niue',
  Code: 'NU',
  Timezone: 'UTC-11',
  UTC: 'UTC-11:00',
  MobileCode: '+683',
}, {
  Name: 'Norfolk Island',
  Code: 'NF',
  Timezone: 'Central Pacific Standard Time',
  UTC: 'UTC+11:00',
  MobileCode: '+672',
}, {
  Name: 'North Korea',
  Code: 'KP',
  Timezone: 'Korea Standard Time',
  UTC: 'UTC+09:00',
  MobileCode: '+850',
}, {
  Name: 'Northern Mariana Islands',
  Code: 'MP',
  Timezone: 'West Pacific Standard Time',
  UTC: 'UTC+10:00',
  MobileCode: '+1-670',
}, {
  Name: 'Norway',
  Code: 'NO',
  Timezone: 'W. Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+47',
}, {
  Name: 'Oman',
  Code: 'OM',
  Timezone: 'Arabian Standard Time',
  UTC: 'UTC+04:00',
  MobileCode: '+968',
}, {
  Name: 'Pakistan',
  Code: 'PK',
  Timezone: 'Pakistan Standard Time',
  UTC: 'UTC+05:00',
  MobileCode: '+92',
}, {
  Name: 'Palau',
  Code: 'PW',
  Timezone: 'Tokyo Standard Time',
  UTC: 'UTC+09:00',
  MobileCode: '+680',
}, {
  Name: 'Palestinian Authority',
  Code: 'PS',
  Timezone: 'Egypt Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+970',
}, {
  Name: 'Panama',
  Code: 'PA',
  Timezone: 'SA Pacific Standard Time',
  UTC: 'UTC-05:00',
  MobileCode: '+507',
}, {
  Name: 'Papua New Guinea',
  Code: 'PG',
  Timezone: 'West Pacific Standard Time',
  UTC: 'UTC+10:00',
  MobileCode: '+675',
}, {
  Name: 'Paraguay',
  Code: 'PY',
  Timezone: 'Paraguay Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+595',
}, {
  Name: 'Peru',
  Code: 'PE',
  Timezone: 'SA Pacific Standard Time',
  UTC: 'UTC-05:00',
  MobileCode: '+51',
}, {
  Name: 'Philippines',
  Code: 'PH',
  Timezone: 'Singapore Standard Time',
  UTC: 'UTC+08:00',
  MobileCode: '+63',
}, {
  Name: 'Pitcairn Islands',
  Code: 'PN',
  Timezone: 'Pacific Standard Time',
  UTC: 'UTC-08:00',
  MobileCode: '+870',
}, {
  Name: 'Poland',
  Code: 'PL',
  Timezone: 'Central European Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+48',
}, {
  Name: 'Portugal',
  Code: 'PT',
  Timezone: 'GMT Standard Time',
  UTC: 'UTC',
  MobileCode: '+351',
}, {
  Name: 'Puerto Rico',
  Code: 'PR',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+1-787 and 1-939',
}, {
  Name: 'Qatar',
  Code: 'QA',
  Timezone: 'Arab Standard Time',
  UTC: 'UTC+03:00',
  MobileCode: '+974',
}, {
  Name: 'Reunion',
  Code: 'RE',
  Timezone: 'Mauritius Standard Time',
  UTC: 'UTC+04:00',
  MobileCode: '+262',
}, {
  Name: 'Romania',
  Code: 'RO',
  Timezone: 'GTB Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+40',
}, {
  Name: 'Russia',
  Code: 'RU',
  Timezone: 'Russian Standard Time',
  UTC: 'UTC+03:00',
  MobileCode: '+7',
}, {
  Name: 'Rwanda',
  Code: 'RW',
  Timezone: 'South Africa Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+250',
}, {
  Name: 'Saint Barth&eacute;lemy',
  Code: 'BL',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+590',
}, {
  Name: 'Saint Helena, Ascension and Tristan da Cunha',
  Code: 'SH',
  Timezone: 'Greenwich Standard Time',
  UTC: 'UTC',
  MobileCode: '+290',
}, {
  Name: 'Saint Kitts and Nevis',
  Code: 'KN',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+1-869',
}, {
  Name: 'Saint Lucia',
  Code: 'LC',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+1-758',
}, {
  Name: 'Saint Martin (French part)',
  Code: 'MF',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+590',
}, {
  Name: 'Saint Pierre and Miquelon',
  Code: 'PM',
  Timezone: 'Greenland Standard Time',
  UTC: 'UTC-03:00',
  MobileCode: '+508',
}, {
  Name: 'Saint Vincent and the Grenadines',
  Code: 'VC',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+1-784',
}, {
  Name: 'Samoa',
  Code: 'WS',
  Timezone: 'Samoa Standard Time',
  UTC: 'UTC+13:00',
  MobileCode: '+685',
}, {
  Name: 'San Marino',
  Code: 'SM',
  Timezone: 'W. Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+378',
}, {
  Name: 'S&atilde;o Tom&eacute; and Pr&iacute;ncipe',
  Code: 'ST',
  Timezone: 'Greenwich Standard Time',
  UTC: 'UTC',
  MobileCode: '+239',
}, {
  Name: 'Saudi Arabia',
  Code: 'SA',
  Timezone: 'Arab Standard Time',
  UTC: 'UTC+03:00',
  MobileCode: '+966',
}, {
  Name: 'Senegal',
  Code: 'SN',
  Timezone: 'Greenwich Standard Time',
  UTC: 'UTC',
  MobileCode: '+221',
}, {
  Name: 'Serbia',
  Code: 'RS',
  Timezone: 'Central Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+381',
}, {
  Name: 'Seychelles',
  Code: 'SC',
  Timezone: 'Mauritius Standard Time',
  UTC: 'UTC+04:00',
  MobileCode: '+248',
}, {
  Name: 'Sierra Leone',
  Code: 'SL',
  Timezone: 'Greenwich Standard Time',
  UTC: 'UTC',
  MobileCode: '+232',
}, {
  Name: 'Singapore',
  Code: 'SG',
  Timezone: 'Singapore Standard Time',
  UTC: 'UTC+08:00',
  MobileCode: '+65',
}, {
  Name: 'Sint Maarten (Dutch part)',
  Code: 'SX',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+599',
}, {
  Name: 'Slovakia',
  Code: 'SK',
  Timezone: 'Central Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+421',
}, {
  Name: 'Slovenia',
  Code: 'SI',
  Timezone: 'Central Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+386',
}, {
  Name: 'Solomon Islands',
  Code: 'SB',
  Timezone: 'Central Pacific Standard Time',
  UTC: 'UTC+11:00',
  MobileCode: '+677',
}, {
  Name: 'Somalia',
  Code: 'SO',
  Timezone: 'E. Africa Standard Time',
  UTC: 'UTC+03:00',
  MobileCode: '+252',
}, {
  Name: 'South Africa',
  Code: 'ZA',
  Timezone: 'South Africa Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+27',
}, {
  Name: 'South Georgia and the South Sandwich Islands',
  Code: 'GS',
  Timezone: 'UTC-02',
  UTC: 'UTC-02:00',
  MobileCode: '+',
}, {
  Name: 'South Sudan',
  Code: 'SS',
  Timezone: 'E. Africa Standard Time',
  UTC: 'UTC+03:00',
  MobileCode: '+211',
}, {
  Name: 'Spain',
  Code: 'ES',
  Timezone: 'Romance Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+34',
}, {
  Name: 'Sri Lanka',
  Code: 'LK',
  Timezone: 'Sri Lanka Standard Time',
  UTC: 'UTC+05:30',
  MobileCode: '+94',
}, {
  Name: 'Sudan',
  Code: 'SD',
  Timezone: 'E. Africa Standard Time',
  UTC: 'UTC+03:00',
  MobileCode: '+249',
}, {
  Name: 'Suriname',
  Code: 'SR',
  Timezone: 'SA Eastern Standard Time',
  UTC: 'UTC-03:00',
  MobileCode: '+597',
}, {
  Name: 'Svalbard',
  Code: 'SJ',
  Timezone: 'W. Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+47',
}, {
  Name: 'Swaziland',
  Code: 'SZ',
  Timezone: 'South Africa Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+268',
}, {
  Name: 'Sweden',
  Code: 'SE',
  Timezone: 'W. Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+46',
}, {
  Name: 'Switzerland',
  Code: 'CH',
  Timezone: 'W. Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+41',
}, {
  Name: 'Syria',
  Code: 'SY',
  Timezone: 'Syria Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+963',
}, {
  Name: 'Taiwan',
  Code: 'TW',
  Timezone: 'Taipei Standard Time',
  UTC: 'UTC+08:00',
  MobileCode: '+886',
}, {
  Name: 'Tajikistan',
  Code: 'TJ',
  Timezone: 'West Asia Standard Time',
  UTC: 'UTC+05:00',
  MobileCode: '+992',
}, {
  Name: 'Tanzania',
  Code: 'TZ',
  Timezone: 'E. Africa Standard Time',
  UTC: 'UTC+03:00',
  MobileCode: '+255',
}, {
  Name: 'Thailand',
  Code: 'TH',
  Timezone: 'SE Asia Standard Time',
  UTC: 'UTC+07:00',
  MobileCode: '+66',
}, {
  Name: 'Togo',
  Code: 'TG',
  Timezone: 'Greenwich Standard Time',
  UTC: 'UTC',
  MobileCode: '+228',
}, {
  Name: 'Tokelau',
  Code: 'TK',
  Timezone: 'Tonga Standard Time',
  UTC: 'UTC+13:00',
  MobileCode: '+690',
}, {
  Name: 'Tonga',
  Code: 'TO',
  Timezone: 'Tonga Standard Time',
  UTC: 'UTC+13:00',
  MobileCode: '+676',
}, {
  Name: 'Trinidad and Tobago',
  Code: 'TT',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+1-868',
}, {
  Name: 'Tunisia',
  Code: 'TN',
  Timezone: 'W. Central Africa Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+216',
}, {
  Name: 'Turkey',
  Code: 'TR',
  Timezone: 'Turkey Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+90',
}, {
  Name: 'Turkmenistan',
  Code: 'TM',
  Timezone: 'West Asia Standard Time',
  UTC: 'UTC+05:00',
  MobileCode: '+993',
}, {
  Name: 'Turks and Caicos Islands',
  Code: 'TC',
  Timezone: 'Eastern Standard Time',
  UTC: 'UTC-05:00',
  MobileCode: '+1-649',
}, {
  Name: 'Tuvalu',
  Code: 'TV',
  Timezone: 'UTC+12',
  UTC: 'UTC+12:00',
  MobileCode: '+688',
}, {
  Name: 'U.S. Minor Outlying Islands',
  Code: 'UM',
  Timezone: 'UTC-11',
  UTC: 'UTC-11:00',
  MobileCode: '+1',
}, {
  Name: 'Uganda',
  Code: 'UG',
  Timezone: 'E. Africa Standard Time',
  UTC: 'UTC+03:00',
  MobileCode: '+256',
}, {
  Name: 'Ukraine',
  Code: 'UA',
  Timezone: 'FLE Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+380',
}, {
  Name: 'United Arab Emirates',
  Code: 'AE',
  Timezone: 'Arabian Standard Time',
  UTC: 'UTC+04:00',
  MobileCode: '+971',
}, {
  Name: 'Uruguay',
  Code: 'UY',
  Timezone: 'Montevideo Standard Time',
  UTC: 'UTC-03:00',
  MobileCode: '+598',
}, {
  Name: 'Uzbekistan',
  Code: 'UZ',
  Timezone: 'West Asia Standard Time',
  UTC: 'UTC+05:00',
  MobileCode: '+998',
}, {
  Name: 'Vanuatu',
  Code: 'VU',
  Timezone: 'Central Pacific Standard Time',
  UTC: 'UTC+11:00',
  MobileCode: '+678',
}, {
  Name: 'Vatican City',
  Code: 'VA',
  Timezone: 'W. Europe Standard Time',
  UTC: 'UTC+01:00',
  MobileCode: '+379',
}, {
  Name: 'Vietnam',
  Code: 'VN',
  Timezone: 'SE Asia Standard Time',
  UTC: 'UTC+07:00',
  MobileCode: '+84',
}, {
  Name: 'Virgin Islands, U.S.',
  Code: 'VI',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+1-340',
}, {
  Name: 'Virgin Islands, British',
  Code: 'VG',
  Timezone: 'SA Western Standard Time',
  UTC: 'UTC-04:00',
  MobileCode: '+1-284',
}, {
  Name: 'Wallis and Futuna',
  Code: 'WF',
  Timezone: 'UTC+12',
  UTC: 'UTC+12:00',
  MobileCode: '+681',
}, {
  Name: 'Yemen',
  Code: 'YE',
  Timezone: 'Arab Standard Time',
  UTC: 'UTC+03:00',
  MobileCode: '+967',
}, {
  Name: 'Zambia',
  Code: 'ZM',
  Timezone: 'South Africa Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+260',
}, {
  Name: 'Zimbabwe',
  Code: 'ZW',
  Timezone: 'South Africa Standard Time',
  UTC: 'UTC+02:00',
  MobileCode: '+263',
}];

let states = '<option value="">Please Select State</option>';

US_STATES.forEach((state) => {
  states += `<option value="${state.abbreviation}">${lowerCaseAllWordsExceptFirstLetters(state.name)}</option>`;
});

export const SELECT_STATES_OPTIONS = states;

export const MONTHS_BILL_SELECT = `<option>Month</option><option value="01">January</option><option value="02">February</option><option value="03">March</option><option value="04">April</option><option value="05">May</option><option value="06">June</option><option value="07">July</option><option value="08">August</option><option value="09">September</option><option value="10">October</option><option value="11">November</option><option value="12">December</option>`;

export const STATE_BILL_SELECT = `<select class="form-control field__input field__input--select selcet-fld select-fld" id="cBillState" name="cBillState" aria-required="true" autocomplete="shipping address-level1" autocorrect="off" required><option value="" selected disabled="">Select State</option>${states}</select>`;

export const STATE_SHIP_SELECT = `<select class="form-control field__input field__input--select selcet-fld select-fld" id="cShipState" name="cShipState" aria-required="true" autocomplete="shipping address-level1" autocorrect="off" required><option value="" selected disabled="">Select State</option>${states}</select>`;

export const PROVINCE_BILL_INPUT = '<input class="form-control field__input input-flds" placeholder="Province/State" autocomplete="shipping address-level1" aria-required="true" type="text" id="cBillState" name="cBillState" required />';

export const PROVINCE_SHIP_INPUT = '<input class="form-control field__input input-flds" placeholder="Province/State" autocomplete="shipping address-level1" aria-required="true" type="text" id="cShipState" name="cShipState" required />';

export const ORDER_ICON_PLACEHOLDER = 'data:image/png;base64,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';

// eslint-disable-next-line no-use-before-define
export const UTILS_CSS = '.mobilz{display:none;} .product-link{display:none;} .additionalProduct{clear:both;} .additionalProduct a{display:block;} .additionalProduct img{float:left;} .giftz{margin:10px 0px;} tr.order-voided td{text-decoration:line-through;opacity:0.5;}input.valid {background-color: #f4ffef !important;}select.valid {background-color: #f4ffef !important;}input.invalid {background-color: #fef3f3 !important;}select.invalid {background-color: #fef3f3 !important;}label.invalid {	color: #ff827c;	margin: 0px 0px 3px 100px;	font-size: 12px;	font-family: \'Libre Franklin\', sans-serif;}.processing {	display: none;	background-image: url(data:image/gif;base64,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);	position: fixed;	top: 50%;	left: 50%;	width: 151px;	height: 181px;	transform: translate(-50%, -50%);	border-radius: 10px;	z-index: 2001}#debugInfo{	display:none;	border:1px solid red;	background:#fff;	color:#000;	position: fixed;	top: 50%;	left: 50%;	padding:20px;	transform: translate(-50%, 200%);	border-radius: 10px;	z-index: 2001}.overlay {	display: none;	background: #000;	width: 100%;	height: 100%;	position: fixed;	opacity: 0.5;	z-index: 2000;	top: 0px;	left:0px;}#error_opener {	display: none;}#errorModal .modal-header {	background: var(--bs-danger);	color: #fff;	padding: 0.5rem 0.5rem;	position: relative;}#infoModal .modal-header {	background: var(--bs-primary);	color: #fff;	padding: 0.5rem 0.5rem;	position: relative;}#errorModal .modal-header h5, #infoModal .modal-header h5 {	font-size: 20px;}#errorModal .modal-header button {	border: none;	background: transparent;	color: #fff;	opacity: 0.5;	font-size: 20px;	position: absolute;	right: 5px;	top: 24px;}#errorModal .modal-body, #infoModal .modal-body {	font-size: 18px;}h5.modal-title {	font-size: 15px;}.modal-body p {	margin: 10px 0px;}.modal-body ol li {	list-style: decimal;}#orderButton {	display: inline-block;}#orderButtonOff {	display: none;}.disabled {	filter: grayscale(1) !important;	opacity: 0.5;	cursor: not-allowed;}.product-image{	width:50px;	height:50px;	border:0px solid #dadada;	border-radius:5px;	margin-right:7px;}@media only screen and (max-width: 767px) {	.product-image{		float:left;		width:120px;		height:120px;		margin:5px 10px 10px 5px;	}	.ty-order-entry .product-image{		display:block;		float:none;	}	.oms-entry{		margin:0px 0px 5px 0px;		width:100px;		height:100px;		clear:both;		float:none;		display:block;	}} .swal2-html-container{font-size:19px;line-height:30px;} .swal2-styled.swal2-confirm{font-size:1.5rem;background:#999;display:none !important;} .swal2-container.swal2-backdrop-show, .swal2-container.swal2-noanimation{background: rgba(0,0,0,.5)} .swal2-popup{width:600px;font-size:10px;} .swal2-icon-error{background:#ffdfe2;color:#000;border:1px solid #dc3545;} .swal2-icon-info{background:#e4f8ff;color:#000;border:1px solid #3fc3ee;} .swal2-close:focus, .swal2-close:active, .swal2-close {outline:0 !important;border:none !important;-webkit-outline-style: none !important;} @media only screen and (max-width: 767px) {.swal2-popup{width:100%;} .swal2-html-container{font-size:1.9rem;line-height:2.1rem;} .swal2-styled.swal2-confirm{font-size:1.3rem;} .desktops{display:none;} .mobilz{display:block;} } .suggestion{display:none;background:#d4ebf2;color:#666;position: absolute;bottom: -30px;padding:15px 20px;border-radius: 10px;z-index: 100;cursor:pointer;text-align:center;}.suggestion strong{color:navy;color:#000;font-weight:normal;}.eac-sugg{color:#ccc;}.pendingvalidation{background:url(data:image/gif;base64,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) center left no-repeat; padding-left:35px !important;}';